import React from 'react';

import { SVGComponentProps } from '@/components/chariot-ui/types';

export const Start = (props: SVGComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.0"
    viewBox="0 0 588.000000 588.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
    fill="none"
  >
    <g
      transform="translate(0.000000,588.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path d="M2807 5711 c-70 -23 -122 -57 -181 -121 -52 -56 -81 -108 -101 -187 -23 -87 -23 -2770 0 -2858 34 -127 120 -230 242 -288 63 -30 76 -32 173 -32 97 0 110 2 173 32 79 38 163 114 200 181 60 110 57 40 57 1537 0 1498 3 1427 -58 1538 -37 69 -141 161 -211 188 -80 31 -216 36 -294 10z" />
      <path d="M1420 5182 c-100 -27 -249 -139 -445 -337 -329 -331 -565 -734 -693 -1185 -77 -272 -97 -422 -97 -745 0 -277 14 -416 61 -625 36 -156 116 -387 193 -553 219 -474 630 -929 1075 -1192 328 -193 614 -297 1011 -366 113 -20 166 -23 400 -23 288 -1 348 5 585 54 721 151 1350 588 1764 1225 63 97 191 351 240 477 188 481 234 1005 136 1523 -116 612 -460 1193 -940 1591 -158 131 -246 173 -363 174 -72 0 -174 -30 -236 -70 -124 -80 -191 -207 -191 -359 0 -162 50 -248 230 -396 279 -229 477 -512 589 -840 134 -395 139 -819 14 -1200 -97 -296 -234 -524 -447 -744 -161 -165 -317 -281 -506 -376 -287 -144 -546 -206 -865 -206 -176 0 -282 13 -443 51 -618 149 -1127 608 -1345 1210 -140 388 -147 833 -21 1225 42 131 152 359 225 468 87 130 231 289 362 398 197 166 236 228 245 392 4 71 1 99 -18 156 -43 135 -162 244 -300 275 -87 20 -138 19 -220 -2z" />
    </g>
  </svg>
);
